import React, { useRef, useState } from 'react'
import styled, { css } from 'styled-components'

const ANIMATION_DURATION: number = 1400

type ButtonComponentProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: HTMLCollection | string
  onClick?: (e?: React.MouseEvent) => void
  href?: string
}

const Button = ({ children, onClick, href, ...otherProps }: ButtonComponentProps) => {
	const [rippleState, setRippleState] = useState(false)
	const [rippleStyle, setRippleStyle] = useState({})
	let timeout:any
	const button:any = useRef(null)
	const ripple:any = useRef(null)

	const onMouseDown = (e: React.MouseEvent) => {
		setRippleState(false)
		clearTimeout(timeout)
		
		const size = button.current.offsetWidth
		const pos = button.current.getBoundingClientRect()
		const x = e.pageX - pos.left - size
		const y = e.pageY - pos.top - size

		const newRippleStyle = {
			top: `${y}px`,
			left: `${x}px`,
			width: `${size * 2}px`,
			height: `${size * 2}px`
		}
		setRippleStyle(newRippleStyle)

		setRippleState(true)
		timeout = setTimeout(() => {
			setRippleState(false)
		}, ANIMATION_DURATION)
	}

	return (
	<Container
		ref={button}
		onClick={onClick}
		onMouseDown={onMouseDown}
		{...otherProps}>
		{children}
		<Ripple
			style={rippleStyle}
			ref={ripple}
			ripple={rippleState}
		/>
	</Container>
	)
}

const Container = styled.button`
    background: ${p => p.theme.colors.accent};
    border: none;
    border-radius: 12px;

	padding: 17px;
	margin-top: 18px;
	width: 100%;

	font-weight: bold;
    color: ${p => p.theme.colors.bg};
	font-size: 16px;
	line-height: 22px;
	text-align: center;

	cursor: pointer;

	position: relative;
	overflow: hidden;

    &, &:active {
		outline: none;
	}
`

const Ripple = styled.span<{ ripple: boolean }>`
	background-color: ${p => p.theme.colors.lighterAccent};
	border-radius: 50%;
	pointer-events: none;
	position: absolute;
	transform: scale(0);
	z-index: 1;
	${p => p.ripple && css`
		transform: scale(2);
		transition: transform ${ANIMATION_DURATION}ms, opacity ${ANIMATION_DURATION}ms;
		opacity: 0;
		transform: scale(2);
	`}
`

export default Button
